(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gf-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-gf-cart]');
  if (!root) return;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function setBusy(line, busy) {
    if (line) line.classList.toggle('is-updating', !!busy);
  }

  function applyCart(cart) {
    var sub = root.querySelector('[data-gf-subtotal]');
    var tot = root.querySelector('[data-gf-total]');
    if (sub) sub.textContent = money(cart.total_price);
    if (tot) tot.textContent = money(cart.total_price);
    // Update the global cart badge if present.
    var badge = document.getElementById('cart-badge');
    if (badge) {
      badge.textContent = String(cart.item_count);
      badge.classList.toggle('is-visible', cart.item_count > 0);
    }
  }

  function changeLine(key, quantity, line) {
    setBusy(line, true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // If the line was removed or quantity changed the line set, reload to
        // re-render server-side markup (prices, removed rows) accurately.
        var stillThere = cart.items.some(function (it) { return it.key === key; });
        if (quantity === 0 || !stillThere || cart.items.length === 0) {
          window.location.reload();
          return;
        }
        var input = line && line.querySelector('[data-qty-input]');
        var found = cart.items.filter(function (it) { return it.key === key; })[0];
        if (input && found) input.value = found.quantity;
        var priceEl = line && line.querySelector('.gf-cart__line-price');
        if (priceEl && found) priceEl.lastChild.textContent = money(found.final_line_price);
        applyCart(cart);
        setBusy(line, false);
      })
      .catch(function () {
        setBusy(line, false);
        window.location.reload();
      });
  }

  root.addEventListener('click', function (e) {
    var line = e.target.closest('.gf-cart__line');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var input = line.querySelector('[data-qty-input]');

    if (e.target.closest('[data-qty-remove]')) {
      e.preventDefault();
      changeLine(key, 0, line);
      return;
    }
    if (e.target.closest('[data-qty-down]')) {
      e.preventDefault();
      var down = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
      input.value = down;
      changeLine(key, down, line);
      return;
    }
    if (e.target.closest('[data-qty-up]')) {
      e.preventDefault();
      var up = (parseInt(input.value, 10) || 0) + 1;
      input.value = up;
      changeLine(key, up, line);
      return;
    }
  });

  root.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var line = input.closest('.gf-cart__line');
    var key = line.getAttribute('data-line-key');
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    input.value = qty;
    changeLine(key, qty, line);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.Shopify && Shopify.designMode) return;
  var alert = document.querySelector('.gf-contact__alert');
  if (alert && typeof alert.focus === 'function') {
    alert.focus();
    alert.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DUR = 320;
  var list = document.querySelector('[data-gf-faq]');
  if (!list) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function items() {
    return Array.prototype.slice.call(list.querySelectorAll('.gf-faq-item'));
  }

  function close(item, animate) {
    var body = item.querySelector('.gf-faq-a');
    if (!body) { item.open = false; return; }
    if (!animate || reduce) { item.open = false; return; }
    item.setAttribute('data-gf-animating', '');
    var start = body.scrollHeight;
    body.style.height = start + 'px';
    body.getBoundingClientRect();
    body.style.transition = 'height ' + DUR + 'ms var(--ease-spring)';
    body.style.height = '0px';
    var done = function () {
      item.open = false;
      body.style.height = '';
      body.style.transition = '';
      item.removeAttribute('data-gf-animating');
      body.removeEventListener('transitionend', done);
    };
    body.addEventListener('transitionend', done);
  }

  function open(item, animate) {
    var body = item.querySelector('.gf-faq-a');
    item.open = true;
    if (!body || !animate || reduce) return;
    item.setAttribute('data-gf-animating', '');
    var target = body.scrollHeight;
    body.style.height = '0px';
    body.getBoundingClientRect();
    body.style.transition = 'height ' + DUR + 'ms var(--ease-spring)';
    body.style.height = target + 'px';
    var done = function () {
      body.style.height = '';
      body.style.transition = '';
      item.removeAttribute('data-gf-animating');
      body.removeEventListener('transitionend', done);
    };
    body.addEventListener('transitionend', done);
  }

  items().forEach(function (item) {
    var summary = item.querySelector('.gf-faq-q');
    if (!summary) return;
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (window.Shopify && Shopify.designMode) { item.open = !item.open; return; }
      var isOpen = item.open;
      // single-open accordion
      items().forEach(function (other) {
        if (other !== item && other.open) close(other, true);
      });
      if (isOpen) { close(item, true); } else { open(item, true); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-fys-band"] && !Shopify.designMode) return;
  try {
    
(function () {
  var forms = document.querySelectorAll('.gf-fys-band .fys__search');
  forms.forEach(function (form) {
    var url = form.getAttribute('data-finder-url') || '/pages/find-your-school';
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    form.addEventListener('submit', function (e) {
      var q = (input.value || '').trim();
      if (!q) return; // let the bare finder page load
      e.preventDefault();
      var dest = url + (url.indexOf('?') === -1 ? '?' : '&') + 'q=' + encodeURIComponent(q);
      window.location.href = dest;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-lead-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Populate the school <datalist> from the storefront school index, if present.
  // XSS-safe: only ever set .value via createElement; no innerHTML with remote data.
  if (window.Shopify && Shopify.designMode) return;

  var section = document.currentScript && document.currentScript.closest
    ? document.currentScript.closest('.gf-lead-form')
    : document.querySelector('.gf-lead-form');
  if (!section) return;

  var list = section.querySelector('[data-school-list]');
  if (!list) return;

  // Endpoint is optional; only fetch if the theme exposes one. Fail soft (free-text input still works).
  var endpoint = (window.GhostFit && window.GhostFit.schoolIndexUrl) || null;
  if (!endpoint) return;

  fetch(endpoint, { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      if (!data || !Array.isArray(data.schools)) return;
      var frag = document.createDocumentFragment();
      data.schools.slice(0, 500).forEach(function (name) {
        if (typeof name !== 'string') return;
        var opt = document.createElement('option');
        opt.value = name;
        frag.appendChild(opt);
      });
      list.appendChild(frag);
    })
    .catch(function () { /* fail soft — free text input remains usable */ });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-login"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-gf-login]');
  if (!root) return;

  var tabs = root.querySelectorAll('[data-gf-tab]');
  var panels = root.querySelectorAll('[data-gf-panel]');

  function activate(name) {
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-gf-tab') === name;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panels.forEach(function (p) {
      p.classList.toggle('is-hidden', p.getAttribute('data-gf-panel') !== name);
    });
  }

  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      activate(t.getAttribute('data-gf-tab'));
    });
  });

  // Magic-link panel toggle within the sign-in tab
  var pwBlock = root.querySelector('[data-gf-mode="password"]');
  var magicBlock = root.querySelector('[data-gf-mode="magic"]');
  var openBtn = root.querySelector('[data-gf-magic-open]');
  var closeBtn = root.querySelector('[data-gf-magic-close]');

  if (openBtn && pwBlock && magicBlock) {
    openBtn.addEventListener('click', function () {
      pwBlock.classList.add('is-hidden');
      magicBlock.classList.remove('is-hidden');
      var input = magicBlock.querySelector('input[type="email"]');
      if (input) input.focus();
    });
  }
  if (closeBtn && pwBlock && magicBlock) {
    closeBtn.addEventListener('click', function () {
      magicBlock.classList.add('is-hidden');
      pwBlock.classList.remove('is-hidden');
    });
  }

  // Focus any server-rendered alert (error / success)
  var alert = root.querySelector('.gf-login__alert');
  if (alert && typeof alert.focus === 'function') {
    alert.focus();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-order-tracking"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.querySelector('[data-order-tracking-form]');
  if (!form) return;

  var hint = form.querySelector('[data-order-tracking-hint]');

  function showHint(msg) {
    if (!hint) return;
    hint.textContent = msg;
    hint.hidden = false;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var orderEl = form.querySelector('#gf-track-order');
    var emailEl = form.querySelector('#gf-track-email');
    var order = orderEl ? orderEl.value.trim() : '';
    var email = emailEl ? emailEl.value.trim() : '';

    if (!order || !email) {
      showHint('Please enter both your order number and the email on the order.');
      return;
    }
    if (email.indexOf('@') === -1) {
      showHint('That email doesn’t look right — please check and try again.');
      return;
    }

    if (hint) hint.hidden = true;

    // Shopify has no anonymous storefront order-lookup API. Route the shopper
    // to the account login page where, once signed in, the live authenticated
    // order status (and any fulfillmentwebhook tracking) lives.
    var accountUrl = form.getAttribute('data-account-url') || '/account/login';
    window.location.href = accountUrl;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-search-results"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.gf-search-results [data-gf-sr-tabs]');
  if (!root) return;
  var tabs = root.querySelectorAll('[data-sr-tab]');
  var section = root.closest('.gf-search-results');
  if (!section) return;
  var panels = section.querySelectorAll('[data-sr-panel]');

  function activate(name) {
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-sr-tab') === name;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panels.forEach(function (p) {
      var on = p.getAttribute('data-sr-panel') === name;
      if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
    });
  }

  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      activate(t.getAttribute('data-sr-tab'));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-steps"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSteps(root) {
    var tabs = root.querySelector('[data-gf-steps-tabs]');
    if (!tabs) return;
    var btns = Array.prototype.slice.call(tabs.querySelectorAll('.gf-steps__tab'));
    var panels = {};
    Array.prototype.slice.call(root.querySelectorAll('[data-aud-panel]')).forEach(function (p) {
      panels[p.getAttribute('data-aud-panel')] = p;
    });

    function select(aud) {
      btns.forEach(function (b) {
        var on = b.getAttribute('data-aud') === aud;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      Object.keys(panels).forEach(function (key) {
        if (key === aud) {
          panels[key].removeAttribute('hidden');
        } else {
          panels[key].setAttribute('hidden', '');
        }
      });
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        select(b.getAttribute('data-aud'));
      });
    });
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-gf-steps]')).forEach(initSteps);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
